var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slick-carousel',{key:_vm.carouselKey,ref:"slick",staticClass:"base-slider",attrs:{"options":_vm.slickOptions},on:{"afterChange":_vm.handleAfterChange}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }